import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppInfo } from './appInfo.model';
import { InfoService } from './info.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  @ViewChild('infoDiv') infoDiv: ElementRef;

  info: AppInfo;

  // objeto de la modal
  modalReference: any;

  constructor(
    private infoService: InfoService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.infoService.getSubject().subscribe(info => {
        this.showInfo(info);
    });
  }

  showInfo(info: AppInfo): void {
    this.info = info;
    this.modalReference = this.modalService.open(
      this.infoDiv,
      {
        centered: true,
        backdrop: 'static',
        keyboard: true
      }
    );
  }

  hidenInfo(): void {
    this.modalReference.close();
  }

}
